import { useLocation } from 'react-router-dom';
import { getCurrentRouteDetails } from './UseHeaderTitle';

export const usePageRedirectPath = () => {
  const { pathname } = useLocation();
  const currentRoute = getCurrentRouteDetails(pathname);
  return currentRoute?.redirect ?? '';
};
